module.exports = __webpack_public_path__ + "img/terminal-fill.94f6ae9a.svg";